import React from "react";

import type { AgeRange } from "@/core/types";
import { getAutomationDataAttr } from "@/utils/automationUtils";

export function AgeRangeDisplay({ max, min }: AgeRange) {
  return (
    <div className="tw:flex tw:gap-4">
      <div className="tw:flex tw:flex-col">
        <span className="tw:text-sm tw:font-bold">Lowest Age</span>
        <span {...getAutomationDataAttr("AcceptedAgeRangeMin")}>{min}</span>
      </div>

      <div className="tw:flex tw:flex-col">
        <span className="tw:text-sm tw:font-bold">Highest Age</span>
        <span {...getAutomationDataAttr("AcceptedAgeRangeMax")}>{max}</span>
      </div>

      <div className="tw:border-r tw:border-stroke-quaternary" />
    </div>
  );
}
